import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
	email: string = "";

	constructor(private router: Router) {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
	}

	ngAfterViewInit() {
		//$.getScript('./assets/js/custom.js', function () {});
	}

	ngOnInit() {
	
	}

	subscribe() {
		
	}
	
}
